import React from 'react';
import { Button } from '../components/ui/Button';
import { Select } from '../components/ui/Select';
import { Card, CardContent } from '../components/ui/Card';
const months = [{
  value: '1',
  label: 'January'
}, {
  value: '2',
  label: 'February'
}, {
  value: '3',
  label: 'March'
}, {
  value: '4',
  label: 'April'
}, {
  value: '5',
  label: 'May'
}, {
  value: '6',
  label: 'June'
}, {
  value: '7',
  label: 'July'
}, {
  value: '8',
  label: 'August'
}, {
  value: '9',
  label: 'September'
}, {
  value: '10',
  label: 'October'
}, {
  value: '11',
  label: 'November'
}, {
  value: '12',
  label: 'December'
}];
const days = Array.from({
  length: 31
}, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1)
}));
const years = Array.from({
  length: 10
}, (_, i) => {
  const y = 2026 - i;
  return {
    value: String(y),
    label: String(y)
  };
});
export function ExportCourse() {
  return <div className="space-y-6" data-id="element-1037">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1038">Export Course</h1>

      <Card data-id="element-1039">
        <CardContent className="pt-6 space-y-5 max-w-sm" data-id="element-1040">
          <Select label="Statuses" defaultValue="completed" options={[{
          value: 'completed',
          label: 'Course Completed'
        }, {
          value: 'in_progress',
          label: 'Course in Progress'
        }, {
          value: 'emailed',
          label: 'Certificate Emailed'
        }, {
          value: 'enrolled',
          label: 'Course Enrolled'
        }, {
          value: 'section_progress',
          label: 'Section in Progress'
        }]} data-id="element-1041" />

          <div data-id="element-1042">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1043">
              Start Date
            </label>
            <div className="flex items-center gap-1" data-id="element-1044">
              <select defaultValue="2" className="h-10 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-1045">
                {months.map(m => <option key={m.value} value={m.value} data-id="element-1046">
                    {m.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1047">/</span>
              <select defaultValue="11" className="h-10 w-16 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-1048">
                {days.map(d => <option key={d.value} value={d.value} data-id="element-1049">
                    {d.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1050">/</span>
              <select defaultValue="2026" className="h-10 w-20 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-1051">
                {years.map(y => <option key={y.value} value={y.value} data-id="element-1052">
                    {y.label}
                  </option>)}
              </select>
            </div>
          </div>

          <div data-id="element-1053">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1054">
              End Date
            </label>
            <div className="flex items-center gap-1" data-id="element-1055">
              <select defaultValue="2" className="h-10 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-1056">
                {months.map(m => <option key={m.value} value={m.value} data-id="element-1057">
                    {m.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1058">/</span>
              <select defaultValue="11" className="h-10 w-16 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-1059">
                {days.map(d => <option key={d.value} value={d.value} data-id="element-1060">
                    {d.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1061">/</span>
              <select defaultValue="2026" className="h-10 w-20 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-1062">
                {years.map(y => <option key={y.value} value={y.value} data-id="element-1063">
                    {y.label}
                  </option>)}
              </select>
            </div>
          </div>

          <Select label="Course Name" defaultValue="any" options={[{
          value: 'any',
          label: '<Any>'
        }, {
          value: 'cd17355',
          label: 'Ethics & The Rules (with NAR Code of Ethics)'
        }, {
          value: 'none',
          label: 'NAR Code of Ethics (NO CE CREDIT)'
        }, {
          value: 'fwd17590',
          label: 'Deeds, Fires & Water: Be Prepared'
        }, {
          value: 'cd16995',
          label: 'Are They Represented?'
        }, {
          value: 'cd18311',
          label: 'Mastering Agency Agreements'
        }, {
          value: 'cd16991',
          label: 'A Letter From ADRE'
        }, {
          value: 'cd17085',
          label: "Don't Lose Your License"
        }, {
          value: 'cd17707',
          label: 'BMC #1 AZ Residential-Statutes and Rules'
        }, {
          value: 'cd17708',
          label: 'BMC #2 AZ Residential-Broker Policies'
        }, {
          value: 'cd17709',
          label: 'BMC #3 AZ Residential-Broker Supervision'
        }, {
          value: 'cd18092',
          label: 'BMC #3B Property Management'
        }, {
          value: 'cd16990',
          label: 'What Goes Wrong In Contracts'
        }, {
          value: 'cd18093',
          label: 'Avoid The Oops: Contract Smarts for Agents'
        }, {
          value: 'cd16992',
          label: 'No Secrets'
        }, {
          value: 'cd18149',
          label: 'The Bottom Line of Disclosure'
        }, {
          value: 'ce15753',
          label: 'Your Clients Are Not Mushrooms'
        }, {
          value: 'cd16993',
          label: 'They Are A Protected Class'
        }, {
          value: 'cd15797',
          label: "Fair Housing In Today's World"
        }, {
          value: 'ce17700',
          label: 'Accidental Property Management'
        }, {
          value: 'cd16994',
          label: 'Follow All The Laws'
        }]} data-id="element-1064" />

          <div className="pt-2" data-id="element-1065">
            <Button data-id="element-1066">Export</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}